// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import BranchSvg from '@rsuite/icon-font/lib/flow/Branch';
var Branch = createSvgIcon({
  as: BranchSvg,
  ariaLabel: 'branch',
  category: 'flow',
  displayName: 'Branch'
});
export default Branch;